<template>
  <div class="card card-chat-booking float-left ml-3">
    <div class="card-body">
      <div class="mb-3">
        <b>ส่งคำขอเพื่อประเมินราคา และวันเข้าให้บริการ</b>
      </div>

      <!-- Service purpose -->
      <div class="pb-4" v-if="submitData.service_id === 13 || submitData.service_id === 49">
        <h4 class="pb-2">{{ $t('message.service_request.big_cleaning_purpose') }}</h4>
        <div class="select-jumbo">
          <select name="service_request_purpose_id"
                  :class="{'form-alert': errors.has('service_request_purpose_id')}"
                  v-model="submitData.service_request_purpose_id"
                  v-validate="'required'">
            <option :value="null">เลือกวัตถุประสงค์</option>
            <template v-for="data in serviceRequestPurposes">
              <option :value="data.id">{{ data | multiLangName }}</option>
            </template>
          </select>
        </div>
        <div class="mt-2 text-remark -status-alert" v-if="errors.has('service_request_purpose_id')">
          {{ $t('message.required_field') }}
        </div>
      </div>

      <!-- Service date -->
      <div>
        <h4 class="pb-2">{{ $t('message.service_request.big_cleaning_service_date') }}</h4>
        <div class="multiDatesCalendar datepicker-here"></div>
        <div v-if="errorBookingDate" class="form-alert-text -status-alert">
          {{ $t('message.booking.new_booking.date_is_required') }}
        </div>
        <div class="row mt-3">
          <div class="col-md-3 col-4 p-1" v-for="time, index in availableTimes" :key="index">
            <button class="btn btn-outline-info btn-block btn-small-group text-center"
                    :class="{'active': submitData.service_time === time}"
                    @click="setSelectedTime(time)">{{ time }}
            </button>
          </div>
        </div>
        <div v-if="errorBookingTime" class="form-alert-text -status-alert">{{ $t('message.required_selection') }}</div>
      </div>

      <!-- Building size -->
      <div class="pt-4" v-if="submitData.service_id !== 49">
        <h4 class="pb-2">{{ $t('message.service_request.big_cleaning_building_type') }}</h4>
        <div class="select-jumbo">
          <select name="building_type"
                  :class="{'form-alert': errors.has('building_type')}"
                  v-model="submitData.building_type_id"
                  v-validate="'required'">
            <option :value="null">เลือกประเภทอาคาร</option>
            <template v-for="data in globalState.configData.building_types">
              <option :value="data.id">{{ data | multiLangName }}</option>
            </template>
          </select>
        </div>
        <div class="mt-2 text-remark -status-alert" v-if="errors.has('building_type')">
          {{ $t('message.required_field') }}
        </div>
      </div>

      <!-- Building size -->
      <div class="pt-4">
        <h4>
          {{ (submitData.service_id === 49) ? $t('message.service_request.upholstery_cleaning_size') : $t('message.service_request.big_cleaning_building_size') }}
        </h4>
        <div class="text-remark mb-2">
          <i class="fas fa-circle fa-xs -status-pending"></i>&nbsp;{{ (submitData.service_id === 49) ? $t('message.service_request.upholstery_cleaning_size_remark') : $t('message.service_request.big_cleaning_building_size_remark') }}
        </div>
        <textarea
          class="form-control"
          name="building_size"
          id="building_size"
          :placeholder="(submitData.service_id === 49) ? $i18n.t('message.service_request.upholstery_cleaning_size_placeholder') : $i18n.t('message.service_request.big_cleaning_building_size_placeholder')"
          v-model="submitData.building_size"
          :class="{'form-alert': errors.has('building_size')}"
          v-validate="'required'"></textarea>
        <div class="mt-2 text-remark -status-alert" v-if="errors.has('building_size')">
          {{ $t('message.required_field') }}
        </div>
      </div>

      <div class="form-group pt-4">
        <button class="btn btn-block btn-info" @click="submit()">ถัดไป</button>
        <button class="btn btn-block btn btn-outline-secondary" @click="cancelRequest()">ยกเลิก</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import moment from 'moment-timezone'
  import 'air-datepicker'
  import 'air-datepicker/dist/js/i18n/datepicker.en.js'

  export default {
    props: {
      message: Object
    },
    data () {
      return {
        submitData: {
          service_id: 13,
          service_request_purpose_id: null,
          service_date: null,
          service_time: null,
          building_type_id: null,
          building_size: null
        },
        datePicker: null,
        availableTimes: [],
        errorBookingDate: false,
        errorBookingTime: false
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        user: 'auth/getUser'
      }),
      ...mapState('chatBooking', ['messages', 'bookingData']),
      serviceRequestPurposes () {
        return (this.submitData.service_id === 13) ? this.globalState.configData.big_cleaning_types : this.globalState.configData.upholstery_cleaning_types
      }
    },
    methods: {
      onDateChange (selectedDate, datePicker) {
        console.log('check selectedDate', selectedDate)
        console.log('check datePicker', datePicker)
      },
      getItemName (items, id) {
        let itemName = null
        for (let key in items) {
          const item = items[key]
          if (item.id === id) {
            itemName = item.name_th
            break
          }
        }
        return itemName
      },
      sendMessage (action) {
        const message = {
          sender_type: 'user',
          type: 'text',
          label: action.label,
          text: action.text,
          data: action.data
        }
        this.$store.commit('chatBooking/ADD_MESSAGE', message)
      },
      getServiceRequestText () {
        const service = this.getItemName(this.globalState.services, this.submitData.service_id)
        const building = this.getItemName(this.globalState.configData.building_types, this.submitData.building_type_id)
        const buildingSizeLabel = (this.submitData.service_id === 49) ? 'รายละเอียดเฟอร์นิเจอร์' : 'ขนาดอาคาร (ตร.ม.)'
        let selectedDateTime = this.submitData.service_date + ' ' + this.submitData.service_time
        selectedDateTime = moment(selectedDateTime, 'YYYY-MM-DD HH:mm').format('DD MMM YYYY (HH:mm)')
        let text = `<div class="pb-1"><label>${service}</label></div>`
        const serviceIds = [13, 49]
        if (serviceIds.includes(this.submitData.service_id)) {
          const serviceRequestPurposes = (this.submitData.service_id === 49) ? this.globalState.configData.upholstery_cleaning_types : this.globalState.configData.big_cleaning_types
          const purpose = this.getItemName(serviceRequestPurposes, this.submitData.service_request_purpose_id)
          text += `<div>วัตถุประสงค์: ${purpose}</div>`
        }
        text += `<div>วันที่ต้องการใช้บริการ: ${selectedDateTime}</div>`
        if (building) {
          text += `<div>ประเภทอาคาร: ${building}</div>`
        }
        text += `<div>${buildingSizeLabel}: ${this.submitData.building_size}</div>`
        return text
      },
      getValidDateTime () {
        let result = true
        if (!this.submitData.service_date) {
          this.errorBookingDate = true
          result = false
        }
        if (!this.submitData.service_time) {
          this.errorBookingTime = true
          result = false
        }
        return result
      },
      submit () {
        this.$validator.validate().then(valid => {
          const validDateTime = this.getValidDateTime()
          if (valid && validDateTime) {
            const text = this.getServiceRequestText()
            const message = {
              sender_type: 'user',
              type: 'text',
              label: 'created-service-request',
              text: text,
              serviceRequestData: this.submitData,
              data: null
            }
            this.$store.commit('chatBooking/ADD_MESSAGE', message)
          }
        })
      },
      cancelRequest () {
        const action = {
          label: 'cancel-service-request',
          text: 'ยกเลิก'
        }
        this.sendMessage(action)
      },
      setDatePickerLanguage () {
        window.$.fn.datepicker.language['th'] = {
          days: [this.$i18n.t('message.calendar.week.01'), this.$i18n.t('message.calendar.week.02'), this.$i18n.t('message.calendar.week.03'), this.$i18n.t('message.calendar.week.04'), this.$i18n.t('message.calendar.week.05'), this.$i18n.t('message.calendar.week.06'), this.$i18n.t('message.calendar.week.07')],
          daysShort: [this.$i18n.t('message.calendar.week_short.01'), this.$i18n.t('message.calendar.week_short.02'), this.$i18n.t('message.calendar.week_short.03'), this.$i18n.t('message.calendar.week_short.04'), this.$i18n.t('message.calendar.week_short.05'), this.$i18n.t('message.calendar.week_short.06'), this.$i18n.t('message.calendar.week_short.07')],
          daysMin: [this.$i18n.t('message.calendar.week_short.01'), this.$i18n.t('message.calendar.week_short.02'), this.$i18n.t('message.calendar.week_short.03'), this.$i18n.t('message.calendar.week_short.04'), this.$i18n.t('message.calendar.week_short.05'), this.$i18n.t('message.calendar.week_short.06'), this.$i18n.t('message.calendar.week_short.07')],
          months: [this.$i18n.t('message.calendar.month.01'), this.$i18n.t('message.calendar.month.02'), this.$i18n.t('message.calendar.month.03'), this.$i18n.t('message.calendar.month.04'), this.$i18n.t('message.calendar.month.05'), this.$i18n.t('message.calendar.month.06'), this.$i18n.t('message.calendar.month.07'), this.$i18n.t('message.calendar.month.08'), this.$i18n.t('message.calendar.month.09'), this.$i18n.t('message.calendar.month.10'), this.$i18n.t('message.calendar.month.11'), this.$i18n.t('message.calendar.month.12')],
          monthsShort: [this.$i18n.t('message.calendar.month_short.01'), this.$i18n.t('message.calendar.month_short.02'), this.$i18n.t('message.calendar.month_short.03'), this.$i18n.t('message.calendar.month_short.04'), this.$i18n.t('message.calendar.month_short.05'), this.$i18n.t('message.calendar.month_short.06'), this.$i18n.t('message.calendar.month_short.07'), this.$i18n.t('message.calendar.month_short.08'), this.$i18n.t('message.calendar.month_short.09'), this.$i18n.t('message.calendar.month_short.10'), this.$i18n.t('message.calendar.month_short.11'), this.$i18n.t('message.calendar.month_short.12')],
          today: this.$i18n.t('message.calendar.today'),
          clear: 'Clear',
          dateFormat: 'yyyy-mm-dd',
          timeFormat: 'hh:ii aa',
          firstDay: 0
        }
      },
      initDatePicker () {
        this.setDatePickerLanguage()
        this.availableTimes = this.globalState.arrFullTimes
        const minDate = moment().add(1, 'days')
        this.datePicker = window.$('.multiDatesCalendar').datepicker({
          language: 'th',
          minDate: minDate.toDate(),
          onSelect: (fmDate, datePicker) => {
            this.submitData.service_date = fmDate
            this.errorBookingDate = false
          }
        })
      },
      setSelectedTime (time) {
        this.submitData.service_time = time
        this.errorBookingTime = false
      }
    },
    mounted () {
      this.submitData.service_id = Number(this.bookingData.service_id)
      this.initDatePicker()
    }
  }
</script>

<style scoped>
  @import '~air-datepicker/dist/css/datepicker.min.css';

  .input-text-icon {
    float: right;
    margin-right: 1rem;
    margin-top: -2.15rem;
    position: relative;
    font-size: 120%;
    z-index: 2;
    color: #9E9E9E;
  }
</style>



// WEBPACK FOOTER //
// src/components/chatBooking/components/ServiceRequestFirstMessage.vue